module.exports = __webpack_public_path__ + "static/media/glassdoor.ccd8e635.svg";